<div class="main-container">
	<div class="sip-img">
		<img loading="lazy" [attr.data-src]="'/assets/images/sipbannerupdate.png'" alt="sip">
	</div>
	<div class="content">
		<div class="text-content">
			<div class="title">Hi {{userData?.fname?.trim()}},</div>
			<div *ngIf="totalDonations">
				<div class="title-text">You have impacted <strong>{{userData?.aggdonationall?.funds}} {{userData?.aggdonationall?.funds === 1 ? 'life' : 'lives'}}</strong> already.</div>
				<div class="title-text">Keep doing the good with <strong>Ketto SIP!</strong></div>
			</div>
			<div *ngIf="!totalDonations">
				<div class="title-text">Help critical patients recieve immediate</div>
				<div class="title-text">medical treatment. Join <strong>Ketto SIP!</strong></div>
			</div>
		</div>
		<div class="btn">
			<button>Know more<span class="material-icons">navigate_next</span></button>
		</div>
	</div>
</div>